import React from 'react'
import { SvgIcon, makeStyles } from '@material-ui/core'

export const StarFilledIcon = (props) => {
  const useStyles = makeStyles((theme) => ({
    customIcon: {
      fill: props?.fill,
    },
  }));

  const classes = useStyles();
  return (
    <SvgIcon {...props} className={classes.customIcon}>
      <path d="M0.884795 8.26672L3.25813 10.0001L2.3568 12.7914C2.21114 13.2243 2.20929 13.6927 2.35154 14.1268C2.49378 14.5608 2.77249 14.9373 3.14613 15.2C3.51336 15.4712 3.95839 15.6165 4.4149 15.6142C4.87141 15.6119 5.31496 15.4622 5.67946 15.1874L8.00013 13.4794L10.3215 15.1854C10.688 15.455 11.1307 15.6015 11.5857 15.6037C12.0408 15.6059 12.4848 15.4638 12.854 15.1977C13.2232 14.9317 13.4985 14.5554 13.6403 14.123C13.7822 13.6907 13.7833 13.2244 13.6435 12.7914L12.7421 10.0001L15.1155 8.26672C15.4816 7.99906 15.7537 7.62255 15.893 7.19098C16.0324 6.7594 16.0317 6.29484 15.8912 5.86364C15.7508 5.43244 15.4776 5.05667 15.1108 4.78999C14.744 4.52331 14.3023 4.37936 13.8488 4.37872H10.9335L10.0488 1.62138C9.90968 1.18736 9.63631 0.808727 9.26811 0.540094C8.89991 0.271462 8.45591 0.126709 8.00013 0.126709C7.54435 0.126709 7.10035 0.271462 6.73215 0.540094C6.36395 0.808727 6.09058 1.18736 5.95146 1.62138L5.0668 4.37872H2.15413C1.70062 4.37936 1.25892 4.52331 0.892115 4.78999C0.525307 5.05667 0.252156 5.43244 0.111676 5.86364C-0.0288034 6.29484 -0.0294251 6.7594 0.1099 7.19098C0.249224 7.62255 0.521369 7.99906 0.887462 8.26672H0.884795Z"/>
    </SvgIcon>
  )
}
